import React from 'react';
import { IGroupedFlowsForUserPascalCase } from '@Shared.Angular/@types/core/contracts/queryModel/flows/groupedFlowsForUser';
import { IMapFlowForGetFlowsPascalCase } from '@Shared.Angular/@types/core/contracts/queryModel/flows/mapFlowForGetFlows';
import FlowHeader from '@Client/runner.flows.imin/runner.flows.imin.groupsv2/components/FlowHeader';

type Props = {
  isMobile: boolean;
  groups: IGroupedFlowsForUserPascalCase[];
  onHeaderClick: (flow: IMapFlowForGetFlowsPascalCase) => void;
};

const FlowsTodoGroups = ({ isMobile, groups, onHeaderClick }: Props) => {
  const handleHeaderClick = (flow: IMapFlowForGetFlowsPascalCase) => {
    onHeaderClick(flow);
  };

  return (
    <div className="flows-todo-groups">
      {groups?.map((group, idx) =>
        group.show === undefined || group.show ? (
          <div
            key={idx}
            className={`flow-block ${isMobile ? 'isMobile' : ''}`}
            data-flow-category={group.FlowCategory}
          >
            <div className="flow-block__header">{group.GroupName}</div>

            <div className={`flow-list ${isMobile ? 'isMobile' : ''}`}>
              <ul>
                {!isMobile && (
                  <li>
                    <div className="flow-list__column-title--todo--imin flex flex-row">
                      <div className="flow-list__column-title__flow-icon-square"></div>
                    </div>
                  </li>
                )}
                {[...group.Flows]
                  .sort((a, b) => {
                    const dateA = new Date(a.DueDate).getTime() || 0;
                    const dateB = new Date(b.DueDate).getTime() || 0;
                    return dateA - dateB;
                  })

                  .map((flow) =>
                    flow.show === undefined || flow.show ? (
                      <li key={flow.FlowId}>
                        <FlowHeader
                          isMobile={false}
                          flow={flow}
                          onHeaderClick={handleHeaderClick}
                        />
                      </li>
                    ) : null
                  )}
              </ul>
            </div>
          </div>
        ) : null
      )}
    </div>
  );
};

export default FlowsTodoGroups;
